import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { User } from '../_models';
import { UtilsService } from './utils.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ChatbotApiService {
  currentUser: User;

  constructor(
    private http: HttpClient,
    private utilsService: UtilsService
  ) {}

  chat(message: string, userInfo: { name: string; email: string; phone: string; employeeId: string }): Observable<{ reply: string; pendingAction?: boolean }> {
    const token = this.utilsService.getCurrentUser()?.token;
    const headers = { 'Authorization': `Bearer ${token}` };

    return this.http.post<{ reply: string; pendingAction?: boolean }>(
      `${environment.apiUrl}/chatbot/chat`,
      { message, userInfo },
      { headers }
    );
  }

  getMessages(sessionId: string): Observable<any[]> {
    return this.http.get<any[]>(`${environment.apiUrl}/chatbot/messages/${sessionId}`);
  }

  saveMessage(payload: any): Observable<any> {
    return this.http.post<any>(`${environment.apiUrl}/chatbot/messages`, payload);
  }

  initSession(): Observable<any> {
    const token = this.utilsService.getCurrentUser()?.token;
    const headers = { 'Authorization': `Bearer ${token}` };

    return this.http.post<any>(
      `${environment.apiUrl}/chatbot/sessions/init`,
      { },
      { headers }
    );
  }

  getSessionMessages(sessionId: string): Observable<any[]> {
    return this.http.get<any[]>(`${environment.apiUrl}/chatbot/messages/${sessionId}`);
  }

  getActiveSessionByMerchantId(): Observable<any> {
    const token = this.utilsService.getCurrentUser()?.token;
    const headers = { 'Authorization': `Bearer ${token}` };
    return this.http.get<any>(`${environment.apiUrl}/chatbot/sessions/find-active`, { headers });
  }

  updateSession(sessionId: string, updates: any): Observable<any> {
    return this.http.put<any>(`${environment.apiUrl}/chatbot/sessions/${sessionId}`, updates);
  }

  getAllSessions(): Observable<any[]> {
    const token = this.utilsService.getCurrentUser()?.token;
    const headers = { 'Authorization': `Bearer ${token}` };
    return this.http.get<any[]>(`${environment.apiUrl}/chatbot/sessions/all`, { headers });
  }

  createNewSession(): Observable<any> {
    const token = this.utilsService.getCurrentUser()?.token;
    const headers = { 'Authorization': `Bearer ${token}` };
    return this.http.post<any>(`${environment.apiUrl}/chatbot/sessions/new`, {}, { headers });
  }
}
